import { Component, OnInit, TemplateRef, Inject } from '@angular/core';
import { Router } from '@angular/router';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as XLSX from 'xlsx';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';

import { CatalogDetFacade } from "../../common/facade/CatalogDetFacade";
import { ChecklistFacade } from "../../common/facade/ChecklistFacade";
import { Permissions } from '../../common/model/dictionary/Permissions';
import { Strings } from '../../common/language/strings';
import { res } from '../../common/language/text/res';
import { Tenant } from '../../common/model/Tenant';
import { Organization } from '../../common/model/Organization';
import { LoggerLayoutsFacade } from '../../common/facade/LoggerLayoutsFacade';
import { LoggerLayout } from '../../common/model/LoggerLayout';

// for excel import
type AOA = any[][];

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css']
})
export class TemplateComponent implements OnInit {

  isSpanish = true;
  titleTemplateManager = res.TemplateManager;
  lblChecklistFunctionality = res.ChecklistFunctionality;
  lblSelectAnOption = res.SelectAnOption;
  lblSave = res.Save;
  lblTemplate = res.Template;
  lblDownloadTemplate = res.DownloadTemplate;
  lblDownload = res.Download;
  lblUploadInstructionsFile = res.UploadInstructionsFile;
  lblSelectAFile = res.SelectAFile;
  lblLevelOneTab = res.LevelOneTab;
  lblWeighing = res.Weighing;
  lblLevelTwoCard = res.LevelTwoCard;
  lblLevelThreeTitle = res.LevelThreeTitle;
  lblInstruction = res.Instruction;
  lblAnswers = res.Answers;
  lblActions = res.Actions;
  lblAnswer = res.Answer;
  lblScore = res.Score;
  lblDescription = res.Description;
  lblRequiresTicket = res.RequiresTicket;
  res = res;

  messagesTable: any = {
    emptyMessage: "",
    totalMessage: ""
  }

  //alert
  alerts: any[] = [];
  alertsFileExcel: any[] = [];

  permissionsList: any[] = []
  //Button Flags
  visibleAdd = false
  visibleEdit = false
  backButtonEnable = false;

  // loader
  loading = false;
  messageLoader = '';
  fileNameUpload = '';

  //modal 
  modalAnswers: BsModalRef
  modalActions: BsModalRef
  config = {
    ignoreBackdropClick: false // si es false se cierra el modal dar click fuera de el
  }

  lsTaskType: any[] = []
  lsCatDetResponsibleActivity: any[] = []
  lsInstruction: any[] = []
  rowsAnswer: any = []
  rowsAction: any = []

  // HTML elements
  readonly = true
  btnSaveReadOnly = true
  cmb_functionality: number = -1
  cmb_organization: number = -1

  isCollapsedLayout: boolean = false;
  iconCollapseLayout: string = 'icon-arrow-up'

  public TenantId = 0
  organizationList: Organization[] = [];
  public availableOrganizations: Organization[] = [];
  public availableTenants: Tenant[] = [];


  collapsedLayout(event: any): void {
  }

  expandedLayout(event: any): void {
  }

  toggleCollapseLayout(): void {
    this.isCollapsedLayout = !this.isCollapsedLayout;
    this.iconCollapseLayout = this.isCollapsedLayout ? 'icon-arrow-down' : 'icon-arrow-up';
  }

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private modalService: BsModalService,
    private _facadeChecklist: ChecklistFacade,
    private _facadeCatDet: CatalogDetFacade,
    private _facadeLog: LoggerLayoutsFacade,
    public strings: Strings,
    private _router: Router
  ) {
    this._storage.set('moduleUrl', this._router.url);
  }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();
    let language = 0;
    if (!this.isSpanish) {
      language = 1;
    }
    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    this.messageLoader = 'Cargando'
    this.loading = true

    this.TenantId = this.strings.getTenant();
    this.availableOrganizations = this.strings.getAvailableOrganizations();
    this.organizationList = this.availableOrganizations.filter(Orga => Orga.tenantId == this.TenantId);
    // get TaskType
    this.validatePermissions()
    this._facadeCatDet.Get(3, language).subscribe(result => {
      if (result.completed) {
        result.data.forEach(element => {
          let splits = element.auxiliary.split("|", element.auxiliary.length)
          if (splits[0] == "0" && splits[1] == "1") {
            this.lsTaskType.push(element)
          }
        });
      }
      this.loading = false
    }, error => {
      this.loading = false
      this.addAlert('<strong>' + error + '</strong>', 'danger')
      return
    });

    // get ResponsibleActivity
    this._facadeCatDet.Get(35, language).subscribe(result => {
      if (result.completed) {
        this.lsCatDetResponsibleActivity = result.data
      }
      this.loading = false
    }, error => {
      this.loading = false
      this.addAlert('<strong>' + error + '</strong>', 'danger')
      return
    });

    console.log(this.backButtonEnable);
    if (!this.visibleEdit) {
      this.backButtonEnable = true;
    }
    else {
      this.backButtonEnable = false;
    }
    console.log(this.backButtonEnable);
  }

  onChangeFuncionality() {
    this.alertsFileExcel = []
    this.btnSaveReadOnly = true
    if (this.cmb_functionality == -1) {
      this.lsInstruction = []
      this.readonly = true
    }
    else {
      this.loading = true
      // get TaskType
      this._facadeChecklist.GetActive(this.cmb_functionality).subscribe(result => {
        this.readonly = false
        this.lsInstruction = []
        if (result.completed) {
          if (result.data != null) {
            this.lsInstruction = result.data.instructions
          }
        }
        this.loading = false
      }, error => {
        this.loading = false
        this.lsInstruction = []
        this.addAlert('<strong>' + error + '</strong>', 'danger')

        var log = new LoggerLayout();

        var userInfo = this._storage.get('user');

        log.message = error;
        log.layoutIncidence = 'template';
        log.userName = userInfo.account;
        log.incidenceType = 1;

        this._facadeLog.AddNewIncident(log).subscribe(result => {
          if (result.completed) {
            console.log('Ha ocurrido un error, contacta al administrador del sistema.')
          }
        });

        return
      });
    }
  }

  uploadExcel(event: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      this.addAlert('<strong>¡Error!</strong>' + this.strings.GetText(res.AlertSelectOnlyOneFile), 'danger', 'excel');
      var log = new LoggerLayout();

      var userInfo = this._storage.get('user');

      log.message = this.strings.GetText(res.AlertSelectOnlyOneFile);
      log.layoutIncidence = 'template';
      log.userName = userInfo.account;
      log.incidenceType = 1;

      this._facadeLog.AddNewIncident(log).subscribe(result => {
        if (result.completed) {
          console.log('Ha ocurrido un error, contacta al administrador del sistema.')
        }
      });
      return;
    }

    //check file is valid
    if (!this.validateFile(target.files[0].name, 'xlsx')) {
      this.addAlert('<strong>¡Error!</strong>' + this.strings.GetText(res.AlertOnlyXlsxfilesAreAccepted), 'danger', 'excel');
      var log = new LoggerLayout();

      var userInfo = this._storage.get('user');

      log.message = this.strings.GetText(res.AlertOnlyXlsxfilesAreAccepted);
      log.layoutIncidence = 'template';
      log.userName = userInfo.account;
      log.incidenceType = 1;

      this._facadeLog.AddNewIncident(log).subscribe(result => {
        if (result.completed) {
          console.log('Ha ocurrido un error, contacta al administrador del sistema.')
        }
      });
      return;
    }

    this.fileNameUpload = event.target.files[0].name;

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      if (wb.SheetNames.length != 3) {
        this.addAlert('<strong>¡Error!</strong>' + this.strings.GetText(res.IncorrectLayout), 'danger', 'excel');
        var log = new LoggerLayout();

        var userInfo = this._storage.get('user');

        log.message = this.strings.GetText(res.IncorrectLayout);
        log.layoutIncidence = 'template';
        log.userName = userInfo.account;
        log.incidenceType = 1;

        this._facadeLog.AddNewIncident(log).subscribe(result => {
          if (result.completed) {
            console.log('Ha ocurrido un error, contacta al administrador del sistema.')
          }
        });
        return
      }

      let excelInstructions: AOA = [[], []]
      let excelAnswers: AOA = [[], []]
      let excelActions: AOA = [[], []]

      const wsnameInstructions: string = wb.SheetNames[0];
      const wsInstructions: XLSX.WorkSheet = wb.Sheets[wsnameInstructions];

      const wsnameAnswers: string = wb.SheetNames[1];
      const wsAnswers: XLSX.WorkSheet = wb.Sheets[wsnameAnswers];

      const wsnameActions: string = wb.SheetNames[2];
      const wsActions: XLSX.WorkSheet = wb.Sheets[wsnameActions];

      /* save data */
      excelInstructions = <AOA>(XLSX.utils.sheet_to_json(wsInstructions, { header: 1 }));
      excelAnswers = <AOA>(XLSX.utils.sheet_to_json(wsAnswers, { header: 1 }));
      excelActions = <AOA>(XLSX.utils.sheet_to_json(wsActions, { header: 1 }));

      this.lsInstruction = []
      let continueReading = true
      let orderDisplayInstruction = 1

      excelInstructions.forEach((instructionItem, index) => {
        if (continueReading) {
          if (index != 0 && instructionItem.length > 0) {
            let layoutInstruction = {
              actions: [],
              answers: [],
              availableComment: false,
              availableOtherOption: false,
              catDetTypeAnswerId: 2602,
              checkInstId: 0,
              checkInstImportReferenceId: 0,
              checkSectId: 0,
              checklistSections: [],
              description: "",
              orderDisplay: orderDisplayInstruction,
              qtPhotosMaxRequired: 0,
              qtPhotosMinRequired: 0,
              title: instructionItem[5],
            }

            for (var i = 1; i <= 4; i++) {
              if (i != 2) {
                if (instructionItem[i] != null) {
                  let section = {
                    checklistId: 0,
                    checkSectId: 0,
                    checkSectParentId: 0,
                    description: "",
                    displayTitle: true,
                    instructions: [],
                    lastDateUpdate: "0001-01-01T00:00:00",
                    orderDisplay: 0,
                    sectionWeight: 0.0,
                    title: instructionItem[i]
                  }
                  section.sectionWeight = i == 1 ? instructionItem[2] : 0.0
                  layoutInstruction.checklistSections.push(section)
                }
              }

            }

            let orderDisplayAnswer = 1
            excelAnswers.forEach((answerItem, indexAnswers) => {
              if (answerItem[0] == instructionItem[0]) {
                let answer = {
                  answerText: answerItem[2],
                  answerValue: 0,
                  checkAnswId: 0,
                  checkInstId: 0,
                  lastDateUpdate: "0001-01-01T00:00:00",
                  orderDisplay: orderDisplayAnswer,
                  qtPhotosMaxRequired: 0,
                  qtPhotosMinRequired: 0,
                  requiresAction: false
                }

                if (answerItem[1].toString().toLowerCase() == "n/a") {
                  answer.answerValue = -1
                }
                else {
                  answer.answerValue = answerItem[1]
                }

                if (answerItem[3] != null) {
                  if (answerItem[3].toLowerCase() == "si") {
                    answer.qtPhotosMinRequired = answerItem[4]
                    answer.qtPhotosMaxRequired = answerItem[5]
                  }
                }

                if (answerItem[6] != null) {
                  if (answerItem[6].toLowerCase() == "si") {
                    answer.requiresAction = true
                  }
                }

                orderDisplayAnswer++
                layoutInstruction.answers.push(answer)
              }
            })

            excelActions.forEach((actionItem, indexAction) => {
              if (indexAction != 0) {
                if (actionItem[0] == instructionItem[0]) {
                  let action = {
                    catDetResponsibleActivityId: 0,
                    checkInstId: 0,
                    checklistActionId: 0,
                    checklistId: 0,
                    description: actionItem[1],
                    lastDateUpdate: "0001-01-01T00:00:00",
                    lastUserNameUpdate: "SYSTEM",
                    requiresTicket: false,
                    serviceLevelAgreementDays: actionItem[2]
                  }

                  let responsibleActivity = this.lsCatDetResponsibleActivity.find(x => x.name == actionItem[3].toUpperCase());
                  if (responsibleActivity != null) {
                    action.catDetResponsibleActivityId = responsibleActivity.catDetId
                  }
                  else {
                    continueReading = false
                    this.addAlert('<strong>¡Error!</strong> Ingrese un responsable válido para la acción del renglón ' + (indexAction + 1), 'danger', 'excel');
                    var log = new LoggerLayout();

                    var userInfo = this._storage.get('user');

                    log.message = 'Ingrese un responsable válido para la acción del renglón ' + (indexAction + 1);
                    log.layoutIncidence = 'template';
                    log.userName = userInfo.account;
                    log.incidenceType = 1;

                    this._facadeLog.AddNewIncident(log).subscribe(result => {
                      if (result.completed) {
                        console.log('Ha ocurrido un error, contacta al administrador del sistema.')
                      }
                    });
                  }

                  if (actionItem[4] != null) {
                    if (actionItem[4].toLowerCase() == "si") {
                      action.requiresTicket = true
                    }
                  }
                  layoutInstruction.actions.push(action)
                }
              }
            })
            orderDisplayInstruction++
            this.lsInstruction.push(layoutInstruction)
          }
        }
        else {
          this.lsInstruction = []
        }
        if (index == excelInstructions.length - 1) {
          if (this.lsInstruction.length > 0) {
            this.btnSaveReadOnly = false
          }
        }
      })
    }

    // Actualizar el texto del elemento label con el nombre del archivo
    const label = document.querySelector('.custom-file-label');
    label.textContent = this.fileNameUpload;

    this.addAlert('<strong>Archivo ' + target.files[0].name + ' subido correctamente</strong>', 'success', 'excel');
  }

  validateFile(name: String, extension: String) {
    var ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext == "xls") {
      ext = "xlsx"
    }
    if (ext.toLowerCase() == extension) {
      return true;
    }
    else {
      return false;
    }
  }

  // Guardar Checklist
  saveChecklist() {
    let checklist = {
      catDetChecklistStatusId: 44,
      catDetTaskTypeId: this.cmb_functionality,
      OrganizationId: this.cmb_organization,
      checklistId: 0,
      instructions: this.lsInstruction,
      lastUserNameUpdate: "System",
      sections: []
    }

    this.loading = true;

    this._facadeChecklist.SaveChecklistTemplate(checklist).subscribe(result => {
      if (result.completed) {
        this.addAlert('<strong>' + result.message + '</strong>', 'success')
        this.readonly = true
        this.btnSaveReadOnly = true
      }
      else {
        this.addAlert('<strong>No se pudo guardar checklist, ' + result.message + '</strong>', 'danger')

        var log = new LoggerLayout();

        var userInfo = this._storage.get('user');

        log.message = 'No se pudo guardar checklist, ' + result.message;
        log.layoutIncidence = 'template';
        log.userName = userInfo.account;
        log.incidenceType = 1;

        this._facadeLog.AddNewIncident(log).subscribe(result => {
          if (result.completed) {
            console.log('Ha ocurrido un error, contacta al administrador del sistema.')
          }
        });
      }
      this.loading = false
    }, error => {
      this.loading = false
      this.addAlert('<strong>' + error + '</strong>', 'danger')

      var log = new LoggerLayout();

      var userInfo = this._storage.get('user');

      log.message = error;
      log.layoutIncidence = 'template';
      log.userName = userInfo.account;
      log.incidenceType = 1;

      this._facadeLog.AddNewIncident(log).subscribe(result => {
        if (result.completed) {
          console.log('Ha ocurrido un error, contacta al administrador del sistema.')
        }
      });

      return
    });

  }

  downloadTemplate() {
    let link = document.createElement("a");
    link.download = "plantilla_checklist";
    link.href = "assets/layout/Plantilla_checklist.xlsx";
    link.click();
  }

  // Abrir modal de respuestas para la instrucción seleccionada
  openModalAnswers(template: TemplateRef<any>, objAnswers: any) {
    this.rowsAnswer = objAnswers.answers

    this.modalAnswers = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' }, this.config)
    );
  }

  // Abrir modal de acciones para la instrucción seleccionada
  openModalActions(template: TemplateRef<any>, objActions: any) {
    this.rowsAction = objActions.actions

    this.modalActions = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' }, this.config)
    );
  }

  // añadir alert
  addAlert(message: String, type: String, fileType: String = ''): void {
    if (fileType == 'excel') {
      this.alertsFileExcel = []
      this.alertsFileExcel.push({
        type: type,
        msg: message
      });
    }
    else {
      this.alerts = []
      this.alerts.push({
        type: type,
        msg: message
      });
    }
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent, fileType: String): void {
    this.alertsFileExcel = this.alertsFileExcel.filter(alert => alert !== dismissedAlert);
  }

  validatePermissions() {
    this.permissionsList = this._storage.get('permissions')
    this.permissionsList.forEach(element => {
      if (element.name == Permissions.GeneralAccess || element.name == Permissions.PlantillasCreate) {
        this.visibleAdd = true;
      }
    });

    this.permissionsList.forEach(element => {
      if (element.name == Permissions.GeneralAccess || element.name == Permissions.PlantillasEdit) {
        this.visibleEdit = true;
      }
    });
  }
}
